<!--
 * @Author: Gummy
 * @Date: 2023-03-28 09:46:19
 * @LastEditors: Gummy
 * @LastEditTime: 2023-05-08 15:23:53
 * @description:
-->
<template>
  <div class="new-introduce__main">
    <div class="new-introduce__content">
      <div class="title">
        <span class="box">
          华盟动态
          <hm-img type="images" imgName="home_newsh5_01_zh" imgClass="news-h5-icon" class="title-icon-h5 show-h5"/>
        </span>
      </div>
      <div class="news-box">
        <div class="new-col carousel" v-if="bannernewslist.length">
          <template v-for="(item, index) in bannernewslist">
            <div class="show-pc" :key="item.id" v-if="item.activityStatus === '即将开始' && activeBanner === index">
              <div class="toActivity" @click="toAdverDetail(item.id)">
                <div class="activity-icon">
                  活动报名<img src="@/assets/icons/activity-arrow.png" class="arrow-img"/>
                </div>
              </div>
            </div>
          </template>
          <a-carousel
            effect="fade"
            dots-class="slick-dots slick-thumb"
            :afterChange="afterChange1"
            :beforeChange="beforeChange"
            :pauseOnFocus="false"
            :pauseOnHover="false"
            ref="carousel1"
          >
            <div slot="customPaging" slot-scope="props">
              <div class="custom">
                <div class="color" v-if="bannerKey1 === props.i"></div>
              </div>
            </div>
            <div v-for="(item, index) in bannernewslist" :key="index" style="width:100%" class="carousel-content" @click="toAdverDetail(item.id)">
              <img
                :src="item.surfacePlotUrl"
                class="surface-img"
              />
              <div class="show-h5">
                <div class="topdate">
                  <div class="year">{{item.activityEndDate.substring(0,4)}}</div>
                  <div class="data">{{item.activityEndDate.substring(5,7)}}/{{item.activityEndDate.substring(8,10)}}</div>
                </div>
                <div class="bottomtext">
                  <div class="b-t-title text-ellipsis-1">{{item.title}}</div>
                  <div class="text text-ellipsis-1">{{item.summarize}}</div>
                </div>
              </div>
          </div>
          </a-carousel>
        </div>
        <template v-for="(item, index) in articleNewsList" >
          <div class="new-col data-list" :key="item.id" v-if="index === 0 && !isH5">
            <div class="new-date">
              <div class="year">{{moment(bannernewslist[bannerKey1].activityEndDate).year()}}</div>
              <div class="date">{{moment(bannernewslist[bannerKey1].activityEndDate).format('MM/DD')}}</div>
            </div><div class="adivider" v-if="index === 0">
            </div>
            <div class="new-list">
              <div class="label text-ellipsis-1 hover-line" @click="toAdverDetail(bannernewslist[bannerKey1].id)">
                {{bannernewslist[bannerKey1].title}}
              </div>
              <div class="summary text-ellipsis-2 hover-line" @click="toAdverDetail(bannernewslist[bannerKey1].id)">
                {{bannernewslist[bannerKey1].summarize}}
              </div>
            </div>
          </div>

          <div class="new-col data-list" :key="item.id" v-if="index !== 0">
            <div class="new-date">
              <div class="year">{{moment(item.releaseDate).year()}}</div>
              <div class="date">{{moment(item.releaseDate).format('MM/DD')}}</div>
            </div><div class="adivider show-pc" v-if="index === 0">
            </div>
            <div class="new-list show-pc">
              <div class="label text-ellipsis-1 hover-line" @click="toNewDetail(item.id)">
                {{item.title}}
              </div>
              <div class="summary text-ellipsis-2 hover-line" @click="toNewDetail(item.id)">
                {{item.summarize}}
              </div>
            </div>
            <div class="new-list show-h5">
              <div class="label-h5 laebl-ellipsis-2" @click="toNewDetail(item.id)">
                {{item.title}}
              </div>
            </div>
          </div>
        </template>

        <div class="btn-logo">
          <hm-img type="images" imgName="home_news_01_zh" imgClass="news-icon"/>
        </div>
      </div>
      <div class="more-btns">
        <a-button class="btn-advert btn" @click="toNew('news-advertisement')">
          更多活动
        </a-button>
        <a-button type="primary" class="btn-new btn" @click="toNew('news-center')">
          更多新闻
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>

import { PostQueryNewsDocumentList, PostQueryActivityDetailsList } from '@/api/api'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'news-detail',
  data () {
    return {
      bannernewslist: [],
      articleNewsList: [],
      bannerKey1: 0,
      percent1: 0,
      interval1: null,
      activeBanner: 0
    }
  },
  created () {
    this.getNews()
  },
  mounted () {
    this.afterChange1(0)
  },
  watch: {
    percent1 (num) {
      if (num === 100) {
        this.$refs.carousel1.next()
      }
    }
  },
  computed: {
    ...mapGetters(['isH5'])
  },
  methods: {
    moment,
    async getNews () {
      this.bannernewslist = []
      this.articleNewsList = []
      await PostQueryActivityDetailsList({
        pageNum: 1,
        pageSize: 5,
        publishStatus: '0' // 是否隐藏
      }).then(res => {
        if (res.code === '200' && res.data.length !== 0) {
          let resData = res.data[0]
          console.log('%c获取研讨活动列表', 'background-color: green;color: #fff;', resData.list)
          this.bannernewslist = resData.list
        } else {
          this.bannernewslist = []
        }
      })

      await PostQueryNewsDocumentList({
        firstClassify: '媒体报道',
        publishStatus: '1',
        pageNum: 1,
        pageSize: 3
      }).then(res => {
        let resData = res.data
        console.log('%c获取新闻列表 - 媒体报道', 'background-color: green;color: #fff;', resData[0].list)
        if (res.code === '200' && resData.length !== 0) {
          this.articleNewsList = resData[0].list
        } else {
          this.articleNewsList = []
        }
      })

      console.log(this.articleNewsList)
      console.log(this.bannernewslist)
      this.articleNewsList = [{}, ...this.articleNewsList]
    },
    toNewDetail (id) {
      console.log(id)
      this.$router.push({
        path: `/news-center-detail/${id}`
      })
    },
    toAdverDetail (id) {
      this.$router.push({
        path: `/news-advertIntroduction/${id}`
      })
    },
    afterChange1 (key) {
      clearInterval(this.interval1)
      this.percent1 = 0
      this.bannerKey1 = key
      this.interval1 = setInterval(() => {
        if (this.percent1 < 100) {
          this.percent1 += 1
        }
      }, 50)
    },
    beforeChange (from, to) {
      this.activeBanner = to
      // console.log('%c key', 'background-color: green;color: #fff;', from, to)
    },
    toNew (name) {
      this.$router.push({
        name
      })
    }
  }
}
</script>

<style lang="less" scoped>
#hm-web {
.new-introduce{
  &__main{
    width: 100%;
    background-image: linear-gradient(#FFFFFF, #F7F9FB);
  }
  &__content{
    /* height: 818PX; */
    width: 1200PX;
    margin: 0 auto;
    padding: 80PX 0;
    box-sizing: content-box;
    .title{
      font-size: 36PX;
      color: #292F3A;
      font-weight: bolder;
      text-align: center;
      margin-bottom: 60PX;
    }
    .news-box{
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      align-content: space-between;
      height: 525PX;
      width: 100%;
      position: relative;
      .carousel{
        height:326PX;
        width: 588PX;
        /deep/ .ant-carousel .slick-dots-bottom{
          bottom: 17PX
        }
        .custom {
          width: 113PX;
          height: 6PX;
          margin-top: 5PX;
          background-color: #e2ebff;
          border-radius: 10PX;
          cursor: pointer;
          .color {
            height: 100%;
            background-color: #236AFF;
            border-radius: 10PX;
            animation-name: move;
            animation-duration: 5s;
            -webkit-animation-duration: 5s;
            animation-iteration-count: 1;
            animation-timing-function: cubic-bezier(0,0,0,0);
          }
          @keyframes move {
            0%{
              width: 0;
            }
            100%{
              width: 100%;
            }
          }
        }
        .surface-img{
          width: 588PX;
          height:326PX;
          cursor: pointer;
        }
      }
      .data-list{
        position: relative;
        z-index: 9;
        height: 175PX;
        width: 568PX;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding-top: 20PX;
        .new-date{
          color: #3E77FF;
          width: 58PX;
          font-size: 18PX;
          margin-right: 23PX;
          font-weight: bolder;
          .year{
            font-size: 24PX;
            margin-right: 24PX;
          }
        }
        .adivider{
          width: 1PX;
          height: 48PX;
          background-color: #EAF1FF;
          margin-top: 14PX;
        }
        .new-list{
          text-align: left;
          .label{
            font-size: 18PX;
            color: #292F3A;
            font-weight: bolder;
            margin-bottom: 16PX;
            height: 33PX;
            line-height: 38PX;
            width: 486PX;
            cursor: pointer;
          }
          .summary{
            font-size: 16PX;
            color: #6E788B;
            height: 64PX;
            line-height: 32PX;
            cursor: pointer;
          }
          .text-ellipsis-1{
            overflow:hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow:ellipsis;
          }
          .text-ellipsis-2{
            overflow:hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            display: -webkit-box;
            -webkit-box-orient: vertical;
          }
          .hover-line:hover{
            color: #3E77FF;
          }
        }
      }
      .data-list:nth-child(2) {
        width: 588PX;
        .new-list{
          width: 486PX;
        }
        .new-date{
          margin-right: 19PX;
        }
        .adivider{
          margin-right: 24PX;
        }
      }
      .data-list:nth-child(3) {
        height: 152PX;
        padding-top: 0;
      }
      .data-list:nth-child(n+4) {
        border-top: 1PX solid #EAF1FF;
      }
      .btn-logo{
        position: absolute;
        right: 0;
        bottom: 168PX;
        /deep/ .news-icon{
          width: 88PX !important;
        }
      }
    }
    .more-btns{
      text-align: center;
      /deep/.ant-btn{
        font-size: 16PX;
        font-weight: bolder;
        // color: #FFFFFF;
        padding: 0 42PX;
        display: inline-block;
        height: 48PX;
      }
      .btn-advert{
        color: #3E77FF;
        border-color: #3E77FF;
        margin-right: 24PX;
        background-color: #F7F9FB;
      }
      .btn-new{
        background-image: linear-gradient(111deg, #3E77FF 0%, #3BA7FC 100%, #68A4F2 100%);
        border-color: none;
      }
      .btn-new:hover{
        opacity: 0.8;
      }
      .btn-advert:hover{
        background: rgba(61,119,255,0.06)
      }
    }
    .toActivity {
      position: absolute;
      top: 10PX;
      left: -16PX;
      z-index: 98;
      cursor: pointer;
      .activity-icon {
        width: 105PX;
        height: 41PX;
        padding-left: 8PX;
        padding-top: 5PX;
        background-image: url('~@/assets/icons/activity.png');
        background-size: cover;
        font-size: 14PX;
        color: #FFFFFF;
        letter-spacing: 0;
        line-height: 20PX;
        font-weight: 600;
        text-align: center;
      }
      .arrow-img {
        width: 16PX;
        color: #FFFFFF;
        margin-top: -3PX;
        margin-left: 4PX;
      }
    }
  }
}

  @media screen and (max-width: 1200px) {
    .new-introduce{
      &__content{
        width: 100%;
        height: auto;
        margin: 0;
        padding: 90px 40px;;
        box-sizing: border-box;
        .title{
          font-size: 40px;;
          margin-bottom: 60px;
          .box{
            position: relative;
            .title-icon-h5{
              position: absolute;
              right: -16px;
              top: -22px;
            }
          }
          /deep/ .news-h5-icon{
            width: 32px;
          }
        }
        .news-box{
          width: 100%;
          height: auto;
          .carousel{
            // width: 669px;
            width: 100%;
            height: 372px;
            margin-bottom: 20px;
            /deep/ .ant-carousel .slick-dots-bottom{
              // bottom: 40px;
              top: 352px;
            }
            .custom {
              width: 120px;
              height: 6px;
              border-radius: 50px;
              overflow: hidden;
            }
            .surface-img{
              // width: 669px;
              width: 100%;
              height: 372px;
              border-radius: 10px;
              overflow: hidden;
            }
            .carousel-content{
              position: relative;
              .topdate{
                position: absolute;
                right: 24px;
                top: 0;
                background: #236AFF;
                color: #fff;
                font-size: 24px;
                width: 96px;
                text-align: center;
                padding: 8px 0;
              }
              .bottomtext{
                position: absolute;
                bottom: 0;
                left: 0;
                padding: 0 24px 24px;
                color: #fff;
                font-size: 26px;
                width: 100%;
                height: 160px;
                background-image: linear-gradient(180deg, rgba(2,25,77,0.00) 9%, rgba(0,25,77,0.70) 43%, #00194D 100%);
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                border-bottom-right-radius: 10px;
                border-bottom-left-radius: 10px;
                .b-t-title{
                  font-size: 28px;
                  font-weight: bolder;
                }
              }
              .text-ellipsis-1{
                overflow:hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow:ellipsis;
              }
            }

          }
          .data-list{
            padding-top: 0;
            width: 100%!important;
            height: 140px!important;
            justify-content: flex-start;
            align-items: center;
            .new-date{
              width: 68px;
              margin-right: 26px;
              font-size: 26px;
              color: #3E77FF;
              .year{
                font-size: 28px;
              }
            }
            .new-list{
              width: 100%!important;
              .label-h5{
                font-size: 28px;
                height: 80px;
                width: 100%;
                color: #292F3A;
              }
              .laebl-ellipsis-2{
                overflow:hidden;
                text-overflow: ellipsis;
                -webkit-line-clamp: 2;
                display: -webkit-box;
                -webkit-box-orient: vertical;
              }
            }
          }
          .data-list:nth-child(2) {
            border-bottom: 3px solid #EAF1FF;
          }
          .data-list:nth-child(n+4) {
            border-top: 3px solid #EAF1FF;
          }
          .btn-logo{
            bottom: 64px;
            /deep/ .news-icon{
              width: 193px;
            }
          }
        }
        .more-btns{
          margin-top: 60px;
          /deep/.ant-btn{
            font-size: 28px;
            padding: 0 44px;
            height: 80px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/newIntroduce.vue